/* Fashion CITY — 커스텀 상품 페이지: 계정 안내 + 로그인 팝업 + 이어서 하기
   ─────────────────────────────────────────────────────────────
   왜 필요한가:
     스토어 설정이 '계정 필수 + 체크아웃 시 로그인 필수' 라서,
     손님이 디자인을 다 만들고 결제를 눌러야 그제서야 로그인 창을 만납니다.
     그러면 "내 디자인 날아갔나?" 싶어서 그냥 나가버립니다.
     그래서 (1) 미리 알려주고 (2) 담을 때 한 번 더 물어보고
     (3) 혹시 몰라 이 브라우저에 디자인을 저장해 둡니다.

   ※ 이 파일은 fc-po.js 보다 먼저 실행돼야 합니다.
     (장바구니 담기 버튼을 fc-po.js 보다 먼저 잡아채야 하기 때문입니다.)
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('fc-po-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var IN = CFG.loggedIn === true;              // 이미 로그인했는가
  var KEY = 'fcpo-design-' + (CFG.handle || '');
  var THIRTY_DAYS = 1000 * 60 * 60 * 24 * 30;
  var skipOnce = false;                        // "이대로 담기" 를 누른 뒤
  var box = null;

  function panel() { return document.querySelector('[data-fcpo]'); }
  function prop(k) {
    var p = panel();
    return p ? p.querySelector('[data-fcpo-prop="' + k + '"]') : null;
  }
  function val(k) {
    var i = prop(k);
    return (i && !i.disabled) ? String(i.value || '') : '';
  }

  /* ── 이 브라우저에 디자인 기억해 두기 ── */
  function worthSaving() {
    if (val('Text').trim()) return true;
    return /logo/i.test(val('Artwork'));
  }
  function save() {
    if (!worthSaving()) return;
    var link = val('Design link');
    if (!link) return;
    try {
      localStorage.setItem(KEY, JSON.stringify({ link: link, at: Date.now() }));
    } catch (e) {}
  }
  function stored() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.link) return null;
      if (Date.now() - (o.at || 0) > THIRTY_DAYS) return null;
      return o;
    } catch (e) { return null; }
  }
  function forget() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  /* ── 로그인/회원가입으로 보내기 (돌아올 주소를 함께 들고 갑니다) ── */
  function leaveFor(what) {
    save();
    var back = val('Design link') || location.href;
    var path = (what === 'register') ? '/account/register' : '/account/login';
    location.href = path + '?return_url=' + encodeURIComponent(back);
  }

  /* ── 장바구니 버튼 위 안내 줄 ── */
  function addNotice() {
    var p = panel();
    if (!p || p.querySelector('[data-fcpo-acct]')) return;
    var n = document.createElement('p');
    n.setAttribute('data-fcpo-acct', '');
    if (IN) {
      n.className = 'fcpo-acct fcpo-acct--in';
      n.innerHTML = 'You are signed in — this design, your sizes and your mockup all save to your order.';
    } else {
      n.className = 'fcpo-acct';
      n.innerHTML = '<strong>Custom orders need an account.</strong> ' +
        '<a data-fcpo-go="login">Log in</a> or <a data-fcpo-go="register">create one</a> now, ' +
        'or keep building and make it at checkout — either way your design stays with your cart.';
    }
    p.appendChild(n);
  }

  /* ── 이어서 하기 ── */
  function cameFromLink() {
    return /[?&](fct|fcc|fcs)=/.test(String(location.search));
  }
  function addResume() {
    var p = panel();
    if (!p || p.querySelector('[data-fcpo-resume]')) return;
    if (cameFromLink()) return;
    var s = stored();
    if (!s) return;
    var bar = document.createElement('div');
    bar.className = 'fcpo-resume';
    bar.setAttribute('data-fcpo-resume', '');
    bar.innerHTML = '<span>You have a design saved on this device.</span>' +
      '<button type="button" data-fcpo-restore>Pick up where I left off</button>' +
      '<button type="button" data-fcpo-forget aria-label="Dismiss">&times;</button>';
    p.insertBefore(bar, p.firstChild);
  }

  /* ── 팝업 ── */
  function closeBox() {
    if (box && box.parentNode) box.parentNode.removeChild(box);
    box = null;
  }
  function openBox(btn) {
    closeBox();
    box = document.createElement('div');
    box.className = 'fcpo-modal';
    box.setAttribute('data-fcpo-modal', '');
    box.innerHTML =
      '<div class="fcpo-modal__box" role="dialog" aria-modal="true" aria-labelledby="fcpo-modal-h">' +
        '<button type="button" class="fcpo-modal__x" data-fcpo-close aria-label="Close">&times;</button>' +
        '<h3 id="fcpo-modal-h">Custom orders need an account</h3>' +
        '<p>We use it to send your proof, answer questions about your artwork, and keep your logo on file so reorders take one click.</p>' +
        '<p class="fcpo-modal__safe">Your design is safe either way. It stays attached to your cart, and we keep a copy on this device — so even if you close the tab, you can pick up right where you left off.</p>' +
        '<div class="fcpo-modal__btns">' +
          '<button type="button" class="fcpo-modal__go" data-fcpo-go="register">Create an account</button>' +
          '<button type="button" class="fcpo-modal__go2" data-fcpo-go="login">I already have one — log in</button>' +
          '<button type="button" class="fcpo-modal__skip" data-fcpo-skip>Keep building — I will make one at checkout</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(box);
    box.__btn = btn;
    var first = box.querySelector('[data-fcpo-go]');
    if (first) first.focus();
  }

  /* ── 디자인이 아직 덜 찼으면 팝업 대신 fc-po.js 의 안내를 먼저 보여줍니다 ── */
  function designReady() {
    var p = panel();
    if (!p) return false;
    var isLogo = /logo/i.test(val('Artwork'));
    if (!isLogo && !val('Text').trim()) return false;
    if (String(val('Mobile')).replace(/[^0-9]+/g, '').length < 7) return false;
    if (p.querySelector('[data-fcpo-runfield]') && !val('Sizes')) return false;
    return true;
  }

  /* ── 클릭 처리 (fc-po.js 보다 먼저 잡습니다) ── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var go = t.closest('[data-fcpo-go]');
    if (go) {
      e.preventDefault();
      e.stopImmediatePropagation();
      leaveFor(go.getAttribute('data-fcpo-go'));
      return;
    }
    if (t.closest('[data-fcpo-close]') || t.getAttribute('data-fcpo-modal') !== null) {
      if (box && (t.closest('[data-fcpo-close]') || t === box)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeBox();
        return;
      }
    }
    if (t.closest('[data-fcpo-skip]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var b = box && box.__btn;
      closeBox();
      skipOnce = true;
      save();
      if (b) b.click();
      return;
    }
    if (t.closest('[data-fcpo-restore]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var s = stored();
      if (s) location.href = s.link;
      return;
    }
    if (t.closest('[data-fcpo-forget]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      forget();
      var bar = document.querySelector('[data-fcpo-resume]');
      if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
      return;
    }

    var add = t.closest('[name="add"]');
    if (!add) return;
    if (IN || skipOnce) { save(); return; }
    if (!panel() || !designReady()) return;   // fc-po.js 가 먼저 안내하게 둡니다
    e.preventDefault();
    e.stopImmediatePropagation();
    save();
    openBox(add);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (box && e.key === 'Escape') closeBox();
  });

  /* ── 시작 ── */
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (panel()) { addNotice(); addResume(); }
    if (tries > 120) clearInterval(timer);
  }, 250);
  setInterval(save, 4000);
  window.addEventListener('pagehide', save);
})();